const translations = {
  en: {
    // App-wide
    appTitle: "Salinator",
    appSubtitle: "AI-Powered Outreach for Sales",
    
    // Disclaimer
    disclaimer: "Disclaimer",
    pleaseReadAndAccept: "Please read and accept the disclaimer before using the application",
    iAcknowledgeAndAccept: "I acknowledge that I have read the disclaimer and accept its terms",
    accept: "Accept",
    disclaimerRequired: "You must accept the disclaimer to use this application",
    
    // Navigation and common actions
    dashboard: "Dashboard",
    dataTable: "Data Table",
    uploadFile: "Upload File",
    claims: "Claims",
    research: "Research",
    aiAssistant: "AI Assistant",
    admin: "Admin",
    settings: "Settings",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    search: "Search",
    filter: "Filter",
    apply: "Apply",
    reset: "Reset",
    close: "Close",
    confirm: "Confirm",
    loading: "Loading...",
    noData: "No data available",
    assign: "Assign",
    about: "About",

    // Auth related
    login: "Login",
    logout: "Logout",
    username: "Username",
    usernameOrEmail: "Username or Email",
    password: "Password",
    signIn: "Sign In",
    signOut: "Sign Out",
    signedInAs: "Signed in as",
    accountSettings: "Account Settings",
    or: "OR",
    signInWithMicrosoft: "Sign in with Microsoft",
    cookieBlockedTitle: "Your browser is blocking cookies we need",
    cookieBlockedIntroCrossSite: "You are signed in, but the server does not recognise your session, so some pages may fail to load (401 errors). Salinator's sign-in service runs on a different address than this page, so your browser treats the sign-in cookie as a third-party cookie. Third-party cookies appear to be blocked, which is the default in recent versions of Chrome.",
    cookieBlockedIntroSameSite: "You are signed in, but the server does not recognise your session, so some pages may fail to load (401 errors). This usually means your browser is blocking cookies for this site.",
    cookieBlockedWhyTitle: "Why do we need this?",
    cookieBlockedWhy: "We use one secure cookie to remember that you are signed in while you move between pages. It is only used to keep you logged in, never for tracking or advertising. Without it every request is rejected, and you would see \"Failed to load\" and \"401\" errors.",
    cookieBlockedHowTitle: "How to fix it",
    cookieBlockedStepChrome1: "Chrome: click the eye icon at the right end of the address bar and turn on \"Third-party cookies\" for this site.",
    cookieBlockedStepChrome2: "Or go to Settings > Privacy and security > Third-party cookies and add {host} under \"Sites allowed to use third-party cookies\".",
    cookieBlockedStepEdge: "Edge: go to Settings > Cookies and site permissions > Manage and delete cookies and site data, then turn off \"Block third-party cookies\" or add {host} under \"Allow\".",
    cookieBlockedStepReload: "Then reload this page and sign in again.",
    cookieBlockedReload: "Reload page",
    cookieBlockedClose: "Close",
    loggedInAs: "Logged in as",
    switchAccount: "Switch Account",
    userMenu: "User Menu",
    
    // User Settings
    userSettings: "User Settings",
    userInformation: "User Information",
    displayName: "Display Name",
    emailAddress: "Email Address",
    profilePicture: "Profile Picture",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    saveChanges: "Save Changes",
    updateProfile: "Update Profile",
    changePassword: "Change Password",
    profileUpdated: "Profile updated successfully",
    passwordChanged: "Password changed successfully",
    currentPasswordRequired: "Current password is required to change password",
    newPasswordRequired: "New password is required",
    passwordsDoNotMatch: "Passwords do not match",
    invalidCurrentPassword: "Current password is incorrect",
    optional: "Optional",
    placeholderDisplayName: "Enter your display name",
    placeholderEmailAddress: "Enter your email address",
    placeholderCurrentPassword: "Enter your current password", 
    placeholderNewPassword: "Enter your new password",
    placeholderConfirmPassword: "Confirm your new password",
    
    // Lusha Credits
    lushaCredits: "Contact Credits",
    totalCreditsUsed: "Total Credits Used",
    totalEnrichments: "Total Enrichments",
    recentCreditUsage: "Recent Credit Usage",
    date: "Date", 
    contactName: "Contact Name",
    company: "Company",
    credits: "Credits",
    type: "Type",
    emailEnriched: "Email enriched",
    phoneEnriched: "Phone enriched",
    linkedinEnriched: "LinkedIn enriched",
    noCreditUsageFound: "No credit usage found",
    
    // File Upload
    dragDropHere: "Drag & drop an Excel file here",
    selectFile: "or click to select a file",
    supportedFormats: "Supported formats: .xlsx, .xls, .csv",
    uploading: "Uploading...",
    uploadComplete: "Upload Complete",
    processingFile: "Processing file...",
    fileError: "Error processing file",
    tryAgain: "Try again",
    
    // Data Table
    showing: "Showing",
    of: "of",
    entries: "entries",
    page: "Page",
    rowsPerPage: "Rows per page",
    nextPage: "Next page",
    previousPage: "Previous page",
    claim: "Claim",
    unclaim: "Unclaim",
    claimed: "Claimed",
    notClaimed: "Not Claimed",
    claimedBy: "Claimed by",
    claimSelected: "Claim Selected",
    bulkClaim: "Bulk Claim",
    refreshData: "Refresh Data",
    records: "records",
    editRecord: "Edit Record",
    editRecordFields: "Edit the fields below. Only changed fields will be saved.",
    saving: "Saving...",
    bulkAssign: "Bulk Assign",
    bulkAssignRecords: "Bulk Assign Records",
    selectUsersToAssign: "Select users to assign",
    assignAllRecords: "Assign all records (regardless of pagination)",
    assignAllRecordsInfo: "This will assign all records matching your current search and filters to the selected users.",
    allRecords: "all records",
    matchingFilters: "matching current filters",
    selectUsers: "Select Users",
    removeExistingAssignments: "Remove existing assignments before assigning",
    removeExistingWarning: "Warning: This will remove all existing assignments for the selected records before assigning them to the selected users.",
    assigning: "Assigning...",
    
    // Claims
    myClaims: "My Claims",
    allClaims: "All Claims",
    claimStats: "Claim Statistics",
    claimsCount: "Total Claims",
    
    // Research
    researchTitle: "AI-Powered Company Outreach Tools",
    researchDescription: "Explore detailed research on selected companies powered by Perplexity AI. Click on a company to expand and view its research profile.",
    selectCompany: "Please select at least one company to research",
    clickToView: "Click to view research",
    unknownCompany: "Unknown Company",
    addressNotAvailable: "Address not available",
    industryNotSpecified: "Industry not specified",
    loadResearchPrompt: "Click the expand button to load research data for this company.",
    
    // AI Assistant
    askQuestion: "Ask a question...",
    sendMessage: "Send",
    aiTyping: "AI is typing...",
    newChat: "New Chat",
    chatHistory: "Chat History",
    deleteChat: "Delete Chat",
    confirmDelete: "Are you sure you want to delete this chat?",
    history: "History",
    fullscreen: "Fullscreen",
    aiAssistantReady: "Ready to assist you",
    recordsSelected: "records selected",
    askAboutData: "Ask me anything about your data!",
    selectRecordsToAnalyze: "Select records from the table to analyze them with AI.",
    tryAsking: "Try asking",
    summarizeData: "Summarize this data",
    findInsights: "Find insights",
    compareRecords: "Compare records",
    promptSummarize: "Summarize the key information from this data",
    promptInsights: "What insights can you provide about these records?",
    promptCompare: "Compare these records and highlight differences",
    aiAssistantSettings: "AI Assistant Settings",
    adminMode: "Admin Mode",
    modelSelection: "Model Selection",
    gpt4o: "GPT-4o (More Capable)",
    gpt4oMini: "GPT-4o Mini (Recommended)",
    systemPrompt: "System Prompt",
    systemPromptHelp: "Instructions given to the AI about how to analyze your data",
    debugMode: "Debug Mode",
    showApiDetails: "Show API Response Details",
    azureOpenAiConfig: "Azure OpenAI Configuration",
    azureEndpoint: "Azure OpenAI Endpoint",
    apiKey: "API Key",
    deploymentNames: "Deployment Names",
    gpt4oDeployment: "GPT-4o Deployment",
    gpt4oMiniDeployment: "GPT-4o Mini Deployment",
    saveConfig: "Save Configuration",
    
    // Filters & Sorting
    sortAsc: "Sort Ascending",
    sortDesc: "Sort Descending",
    addFilter: "Add Filter",
    clearFilters: "Clear Filters",
    field: "Field",
    operator: "Operator",
    value: "Value",
    equals: "equals",
    notEquals: "not equals",
    contains: "contains",
    notContains: "not contains",
    greaterThan: "greater than",
    lessThan: "less than",
    startsWith: "starts with",
    endsWith: "ends with",
    
    // Admin Panel
    userManagement: "User Management",
    addUser: "Add User",
    editUser: "Edit User",
    deleteUser: "Delete User",
    assignRoles: "Assign Roles",
    
    // Errors and Messages
    error: "Error",
    success: "Success",
    warning: "Warning",
    info: "Information",
    actionComplete: "Action completed successfully",
    confirmAction: "Are you sure you want to perform this action?",
    sessionExpired: "Your session has expired. Please log in again.",
    connectionError: "Connection error. Please check your internet connection.",

    // Sales related
    generateSalesInsights: "Generate Sales Insights",
    salesInsightsFor: "Sales Insights for",
    keySalesOpportunities: "Key Sales Opportunities",
    keyPoints: "Key Points",
    questionsToAsk: "Questions to Ask",
    salesApproaches: "Effective Sales Approaches",
    potentialObjections: "Potential Objections & Responses",
    suggestedResponse: "Suggested Response",
    conclusion: "Conclusion",
    
    // Outreach related
    outreach: "Sales Outreach",
    recordNewOutreach: "Record New Outreach",
    outreachStatistics: "Outreach Statistics",
    outreachMethod: "Outreach Method",
    outreachDate: "Outreach Date & Time",
    reachedContact: "Reached Intended Contact?",
    followupDate: "Follow-up Date & Time",
    meetingScheduled: "Meeting Scheduled?",
    meetingDate: "Meeting Date & Time",
    notes: "Notes",
    followupDetails: "Follow-up Details",
    totalOutreaches: "Total Outreaches",
    successfulContacts: "Successful Contacts",
    successRate: "Success Rate",
    meetingsScheduled: "Meetings Scheduled",
    conversionRate: "Conversion Rate",
    phone: "Phone",
    email: "Email",
    linkedin: "LinkedIn",
    outreachStatus: "Outreach Status",
    
    // Company Information - Dutch business terms (keep as is in English too)
    Correspondentieadres: "Correspondentieadres",
    "Correspondentieadres Straat": "Correspondentieadres Straat",
    "Correspondentieadres Huisnummer": "Correspondentieadres Huisnummer",
    "Correspondentieadres Toevoeging": "Correspondentieadres Toevoeging",
    "Correspondentieadres Postcode": "Correspondentieadres Postcode",
    "Correspondentieadres Plaats": "Correspondentieadres Plaats",
    Telefoonnummer: "Telefoonnummer",
    "Telefoonnummer Mobiel": "Telefoonnummer Mobiel",
    URL: "URL",
    "Company.Info Link": "Company.Info Link",
    "LinkedIn Link": "LinkedIn Link",
    "Kamer van Koophandel nummer": "Kamer van Koophandel nummer",
    Vestigingsnummer: "Vestigingsnummer",
    "Rechtsvorm Omschrijving": "Rechtsvorm Omschrijving",
    "Klasse Aantal Medewerkers Locatie_Omschrijving": "Klasse Aantal Medewerkers Locatie_Omschrijving",
    "SBI-code locatie": "SBI-code locatie",
    "SBI-code locatie_Omschrijving": "SBI-code locatie_Omschrijving",
    "SBI-code 2-cijferig Locatie": "SBI-code 2-cijferig Locatie",
    "SBI-code 2-cijferig Locatie_Omschrijving": "SBI-code 2-cijferig Locatie_Omschrijving",
    Mailstop: "Mailstop",
    "SizoKey Ultimate Parent": "SizoKey Ultimate Parent",
    "Instellingsnaam Ultimate Parent": "Instellingsnaam Ultimate Parent",
    "Klasse Aantal Medewerkers Concern_Omschrijving": "Klasse Aantal Medewerkers Concern_Omschrijving",
    "Klasse Aantal Locaties Van Concern_Omschrijving": "Klasse Aantal Locaties Van Concern_Omschrijving",
    "Company.info_IT_gedragstype": "Company.info_IT_gedragstype",
    DMU_Locatie: "DMU_Locatie",
    DMU_Concern: "DMU_Concern",
    "CP Functie Code Verantwoordelijk Bedrijfsvoering_Omschrijving": "CP Functie Code Verantwoordelijk Bedrijfsvoering_Omschrijving",
    "CP Titel Verantwoordelijk Bedrijfsvoering": "CP Titel Verantwoordelijk Bedrijfsvoering",
    "CP Voorletters Verantwoordelijk Bedrijfsvoering": "CP Voorletters Verantwoordelijk Bedrijfsvoering",
    "CP Tussenvoegsel Verantwoordelijk Bedrijfsvoering": "CP Tussenvoegsel Verantwoordelijk Bedrijfsvoering",
    "CP Achternaam Verantwoordelijk Bedrijfsvoering": "CP Achternaam Verantwoordelijk Bedrijfsvoering",
    claimed_by: "claimed_by",
    locationsNotSpecified: "locationsNotSpecified",
    
    // Custom Fields
    Filter1: "Filter 1",
    Filter2: "Filter 2", 
    Filter3: "Filter 3",
    Notities: "Notes",
    
    // Additional Company Information
    "Vestigingsadres Plaats": "Vestigingsadres Plaats",
  },
  nl: {
    // App-wide
    appTitle: "Salinator",
    appSubtitle: "AI-Powered Outreach for Sales",
    
    // Disclaimer
    disclaimer: "Disclaimer",
    pleaseReadAndAccept: "Lees en accepteer de disclaimer voordat je de applicatie gebruikt",
    iAcknowledgeAndAccept: "Ik bevestig dat ik de disclaimer heb gelezen en de voorwaarden accepteer",
    accept: "Accepteren",
    disclaimerRequired: "Je moet de disclaimer accepteren om deze applicatie te gebruiken",
    
    // Navigation and common actions
    dashboard: "Dashboard",
    dataTable: "Gegevenstabel",
    uploadFile: "Bestand Uploaden",
    claims: "Claims",
    research: "Onderzoek",
    aiAssistant: "AI Assistent",
    admin: "Beheer",
    settings: "Instellingen",
    save: "Opslaan",
    cancel: "Annuleren",
    delete: "Verwijderen",
    edit: "Bewerken",
    view: "Bekijken",
    search: "Zoeken",
    filter: "Filteren",
    apply: "Toepassen",
    reset: "Herstellen",
    close: "Sluiten",
    confirm: "Bevestigen",
    loading: "Laden...",
    noData: "Geen gegevens beschikbaar",
    assign: "Toewijzen",
    about: "Over",

    // Auth related
    login: "Inloggen",
    logout: "Uitloggen",
    username: "Gebruikersnaam",
    usernameOrEmail: "Gebruikersnaam of E-mail",
    password: "Wachtwoord",
    signIn: "Inloggen",
    signOut: "Uitloggen",
    signedInAs: "Ingelogd als",
    accountSettings: "Account Instellingen",
    or: "OF",
    signInWithMicrosoft: "Inloggen met Microsoft",
    cookieBlockedTitle: "Je browser blokkeert cookies die we nodig hebben",
    cookieBlockedIntroCrossSite: "Je bent ingelogd, maar de server herkent je sessie niet, waardoor sommige pagina's niet laden (401-fouten). De inlogdienst van Salinator draait op een ander adres dan deze pagina, waardoor je browser de inlogcookie als cookie van derden (third-party cookie) beschouwt. Cookies van derden lijken geblokkeerd te worden, wat de standaardinstelling is in recente versies van Chrome.",
    cookieBlockedIntroSameSite: "Je bent ingelogd, maar de server herkent je sessie niet, waardoor sommige pagina's niet laden (401-fouten). Dit betekent meestal dat je browser cookies voor deze site blokkeert.",
    cookieBlockedWhyTitle: "Waarom hebben we dit nodig?",
    cookieBlockedWhy: "We gebruiken één beveiligde cookie om te onthouden dat je bent ingelogd terwijl je door de pagina's navigeert. De cookie wordt alleen gebruikt om je ingelogd te houden, nooit voor tracking of advertenties. Zonder deze cookie wordt elk verzoek geweigerd en zie je de foutmeldingen \"Laden mislukt\" en \"401\".",
    cookieBlockedHowTitle: "Zo los je het op",
    cookieBlockedStepChrome1: "Chrome: klik op het oogpictogram aan de rechterkant van de adresbalk en zet \"Cookies van derden\" aan voor deze site.",
    cookieBlockedStepChrome2: "Of ga naar Instellingen > Privacy en beveiliging > Cookies van derden en voeg {host} toe onder \"Sites die cookies van derden mogen gebruiken\".",
    cookieBlockedStepEdge: "Edge: ga naar Instellingen > Cookies en sitemachtigingen > Cookies en sitegegevens beheren en verwijderen, en zet \"Cookies van derden blokkeren\" uit of voeg {host} toe onder \"Toestaan\".",
    cookieBlockedStepReload: "Laad daarna deze pagina opnieuw en log opnieuw in.",
    cookieBlockedReload: "Pagina herladen",
    cookieBlockedClose: "Sluiten",
    loggedInAs: "Ingelogd als",
    switchAccount: "Account Wisselen",
    userMenu: "Gebruikersmenu",
    
    // User Settings
    userSettings: "Gebruikersinstellingen",
    userInformation: "Gebruikersinformatie",
    displayName: "Weergavenaam",
    emailAddress: "E-mailadres",
    profilePicture: "Profielafbeelding",
    currentPassword: "Huidig wachtwoord",
    newPassword: "Nieuw wachtwoord",
    confirmPassword: "Wachtwoord bevestigen",
    saveChanges: "Wijzigingen opslaan",
    updateProfile: "Profiel bijwerken",
    changePassword: "Wachtwoord wijzigen",
    profileUpdated: "Profiel succesvol bijgewerkt",
    passwordChanged: "Wachtwoord succesvol gewijzigd",
    currentPasswordRequired: "Huidig wachtwoord is vereist om wachtwoord te wijzigen",
    newPasswordRequired: "Nieuw wachtwoord is vereist",
    passwordsDoNotMatch: "Wachtwoorden komen niet overeen",
    invalidCurrentPassword: "Huidig wachtwoord is onjuist",
    optional: "Optioneel",
    placeholderDisplayName: "Voer uw weergavenaam in",
    placeholderEmailAddress: "Voer uw e-mailadres in", 
    placeholderCurrentPassword: "Voer uw huidig wachtwoord in",
    placeholderNewPassword: "Voer uw nieuw wachtwoord in",
    placeholderConfirmPassword: "Voer uw nieuw wachtwoord opnieuw in",
    
    // Lusha Credits
    lushaCredits: "Contact Credits",
    totalCreditsUsed: "Totaal Gebruikte Credits",
    totalEnrichments: "Totaal Verrijkingen",
    recentCreditUsage: "Recent Creditgebruik",
    date: "Datum",
    contactName: "Contactnaam",
    company: "Bedrijf",
    credits: "Credits",
    type: "Type",
    emailEnriched: "E-mail verrijkt",
    phoneEnriched: "Telefoon verrijkt",
    linkedinEnriched: "LinkedIn verrijkt",
    noCreditUsageFound: "Geen creditgebruik gevonden",
    
    // File Upload
    dragDropHere: "Sleep een Excel bestand hierheen",
    selectFile: "of klik om een bestand te selecteren",
    supportedFormats: "Ondersteunde formaten: .xlsx, .xls, .csv",
    uploading: "Uploaden...",
    uploadComplete: "Upload Voltooid",
    processingFile: "Bestand verwerken...",
    fileError: "Fout bij verwerken bestand",
    tryAgain: "Probeer opnieuw",
    
    // Data Table
    showing: "Toont",
    of: "van",
    entries: "rijen",
    page: "Pagina",
    rowsPerPage: "Rijen per pagina",
    nextPage: "Volgende pagina",
    previousPage: "Vorige pagina",
    claim: "Claimen",
    unclaim: "Vrijgeven",
    claimed: "Geclaimd",
    notClaimed: "Niet Geclaimd",
    claimedBy: "Geclaimd door",
    claimSelected: "Selectie Claimen",
    bulkClaim: "Bulk Claimen",
    refreshData: "Gegevens Vernieuwen",
    records: "records",
    editRecord: "Record Bewerken",
    editRecordFields: "Bewerk de velden hieronder. Alleen gewijzigde velden worden opgeslagen.",
    saving: "Opslaan...",
    bulkAssign: "Bulk Toewijzen",
    bulkAssignRecords: "Bulk Records Toewijzen",
    selectUsersToAssign: "Selecteer gebruikers om toe te wijzen",
    assignAllRecords: "Wijs alle records toe (ongeacht paginering)",
    assignAllRecordsInfo: "Dit wijst alle records toe die overeenkomen met uw huidige zoekopdracht en filters aan de geselecteerde gebruikers.",
    allRecords: "alle records",
    matchingFilters: "die overeenkomen met huidige filters",
    selectUsers: "Selecteer Gebruikers",
    removeExistingAssignments: "Verwijder bestaande toewijzingen voordat u toewijst",
    removeExistingWarning: "Waarschuwing: Dit verwijdert alle bestaande toewijzingen voor de geselecteerde records voordat ze aan de geselecteerde gebruikers worden toegewezen.",
    assigning: "Toewijzen...",
    
    // Claims
    myClaims: "Mijn Claims",
    allClaims: "Alle Claims",
    claimStats: "Claim Statistieken",
    claimsCount: "Totaal Claims",
    
    // Research
    researchTitle: "AI-Bedrijfsonderzoek",
    researchDescription: "Ontdek gedetailleerd onderzoek van geselecteerde bedrijven met Perplexity AI. Klik op een bedrijf om het onderzoeksprofiel te bekijken.",
    selectCompany: "Selecteer ten minste één bedrijf om te onderzoeken",
    clickToView: "Klik om onderzoek te bekijken",
    unknownCompany: "Onbekend Bedrijf",
    addressNotAvailable: "Adres niet beschikbaar",
    industryNotSpecified: "Branche niet gespecificeerd",
    loadResearchPrompt: "Klik op de uitvouwknop om onderzoeksgegevens voor dit bedrijf te laden.",
    
    // AI Assistant
    askQuestion: "Stel een vraag...",
    sendMessage: "Versturen",
    aiTyping: "AI is aan het typen...",
    newChat: "Nieuwe Chat",
    chatHistory: "Chatgeschiedenis",
    deleteChat: "Chat Verwijderen",
    confirmDelete: "Weet je zeker dat je deze chat wilt verwijderen?",
    history: "Geschiedenis",
    fullscreen: "Volledig scherm",
    aiAssistantReady: "Klaar om je te helpen",
    recordsSelected: "rijen geselecteerd",
    askAboutData: "Vraag me iets over je data!",
    selectRecordsToAnalyze: "Selecteer rijen uit de tabel om ze met AI te analyseren.",
    tryAsking: "Probeer te vragen",
    summarizeData: "Maak samenvatting",
    findInsights: "Insights vinden",
    compareRecords: "Vergelijk rijen",
    promptSummarize: "Vat de belangrijkste informatie uit deze data samen",
    promptInsights: "Wat kun je vertellen over deze rijen?",
    promptCompare: "Vergelijk deze rijen en markeer verschillen",
    aiAssistantSettings: "AI Assistent Instellingen",
    adminMode: "Beheer Modus",
    modelSelection: "Model Selectie",
    gpt4o: "GPT-4o (Meer Capabel)",
    gpt4oMini: "GPT-4o Mini (Aanbevolen)",
    systemPrompt: "Systeem Prompt",
    systemPromptHelp: "Instructies gegeven aan de AI over hoe je je data moet analyseren",
    debugMode: "Foutopsporing Modus",
    showApiDetails: "API Response Details Weergeven",
    azureOpenAiConfig: "Azure OpenAI Configuratie",
    azureEndpoint: "Azure OpenAI Endpoint",
    apiKey: "API Sleutel",
    deploymentNames: "Implementatienaam",
    gpt4oDeployment: "GPT-4o Implementatie",
    gpt4oMiniDeployment: "GPT-4o Mini Implementatie",
    saveConfig: "Configuratie Opslaan",
    
    // Filters & Sorting
    sortAsc: "Oplopend Sorteren",
    sortDesc: "Aflopend Sorteren",
    addFilter: "Filter Toevoegen",
    clearFilters: "Filters Wissen",
    field: "Veld",
    operator: "Operator",
    value: "Waarde",
    equals: "is gelijk aan",
    notEquals: "is niet gelijk aan",
    contains: "bevat",
    notContains: "bevat niet",
    greaterThan: "groter dan",
    lessThan: "kleiner dan",
    startsWith: "begint met",
    endsWith: "eindigt op",
    
    // Admin Panel
    userManagement: "Gebruikersbeheer",
    addUser: "Gebruiker Toevoegen",
    editUser: "Gebruiker Bewerken",
    deleteUser: "Gebruiker Verwijderen",
    assignRoles: "Rollen Toewijzen",
    
    // Errors and Messages
    error: "Fout",
    success: "Succes",
    warning: "Waarschuwing",
    info: "Informatie",
    actionComplete: "Actie succesvol afgerond",
    confirmAction: "Weet je zeker dat je deze actie wilt uitvoeren?",
    sessionExpired: "Je sessie is verlopen. Log opnieuw in.",
    connectionError: "Verbindingsfout. Controleer je internetverbinding.",

    // Sales related
    generateSalesInsights: "Genereer Verkoopinzichten",
    salesInsightsFor: "Verkoopinzichten voor",
    keySalesOpportunities: "Belangrijke Verkoopkansen",
    keyPoints: "Kernpunten",
    questionsToAsk: "Te Stellen Vragen",
    salesApproaches: "Effectieve Verkoopbenaderingen",
    potentialObjections: "Mogelijke Bezwaren & Antwoorden",
    suggestedResponse: "Voorgesteld Antwoord",
    conclusion: "Conclusie",
    
    // Outreach related
    outreach: "Sales Outreach",
    recordNewOutreach: "Nieuwe Outreach Registreren",
    outreachStatistics: "Outreach Statistieken",
    outreachMethod: "Contact Methode",
    outreachDate: "Contact Datum & Tijd",
    reachedContact: "Beoogde Contactpersoon Bereikt?",
    followupDate: "Opvolgdatum & Tijd",
    meetingScheduled: "Afspraak Ingepland?",
    meetingDate: "Afspraak Datum & Tijd",
    notes: "Notities",
    followupDetails: "Opvolgdetails",
    totalOutreaches: "Totaal Aantal Contacten",
    successfulContacts: "Succesvolle Contacten",
    successRate: "Succes Percentage",
    meetingsScheduled: "Ingeplande Afspraken",
    conversionRate: "Conversie Percentage",
    phone: "Telefoon",
    email: "E-mail",
    linkedin: "LinkedIn",
    outreachStatus: "Contact Status",
    
    // Company Information - Dutch business terms (keep as is)
    Correspondentieadres: "Correspondentieadres",
    "Correspondentieadres Straat": "Correspondentieadres Straat",
    "Correspondentieadres Huisnummer": "Correspondentieadres Huisnummer",
    "Correspondentieadres Toevoeging": "Correspondentieadres Toevoeging",
    "Correspondentieadres Postcode": "Correspondentieadres Postcode",
    "Correspondentieadres Plaats": "Correspondentieadres Plaats",
    Telefoonnummer: "Telefoonnummer",
    "Telefoonnummer Mobiel": "Telefoonnummer Mobiel",
    URL: "URL",
    "Company.Info Link": "Company.Info Link",
    "LinkedIn Link": "LinkedIn Link",
    "Kamer van Koophandel nummer": "Kamer van Koophandel nummer",
    Vestigingsnummer: "Vestigingsnummer",
    "Rechtsvorm Omschrijving": "Rechtsvorm Omschrijving",
    "Klasse Aantal Medewerkers Locatie_Omschrijving": "Klasse Aantal Medewerkers Locatie_Omschrijving",
    "SBI-code locatie": "SBI-code locatie",
    "SBI-code locatie_Omschrijving": "SBI-code locatie_Omschrijving",
    "SBI-code 2-cijferig Locatie": "SBI-code 2-cijferig Locatie",
    "SBI-code 2-cijferig Locatie_Omschrijving": "SBI-code 2-cijferig Locatie_Omschrijving",
    Mailstop: "Mailstop",
    "SizoKey Ultimate Parent": "SizoKey Ultimate Parent",
    "Instellingsnaam Ultimate Parent": "Instellingsnaam Ultimate Parent",
    "Klasse Aantal Medewerkers Concern_Omschrijving": "Klasse Aantal Medewerkers Concern_Omschrijving",
    "Klasse Aantal Locaties Van Concern_Omschrijving": "Klasse Aantal Locaties Van Concern_Omschrijving",
    "Company.info_IT_gedragstype": "Company.info_IT_gedragstype",
    DMU_Locatie: "DMU_Locatie",
    DMU_Concern: "DMU_Concern",
    "CP Functie Code Verantwoordelijk Bedrijfsvoering_Omschrijving": "CP Functie Code Verantwoordelijk Bedrijfsvoering_Omschrijving",
    "CP Titel Verantwoordelijk Bedrijfsvoering": "CP Titel Verantwoordelijk Bedrijfsvoering",
    "CP Voorletters Verantwoordelijk Bedrijfsvoering": "CP Voorletters Verantwoordelijk Bedrijfsvoering",
    "CP Tussenvoegsel Verantwoordelijk Bedrijfsvoering": "CP Tussenvoegsel Verantwoordelijk Bedrijfsvoering",
    "CP Achternaam Verantwoordelijk Bedrijfsvoering": "CP Achternaam Verantwoordelijk Bedrijfsvoering",
    claimed_by: "claimed_by",
    locationsNotSpecified: "locationsNotSpecified",
    
    // Custom Fields
    Filter1: "Filter 1",
    Filter2: "Filter 2", 
    Filter3: "Filter 3",
    Notities: "Notities",
    
    // Additional Company Information
    "Vestigingsadres Plaats": "Vestigingsadres Plaats",
  }
};

export default translations;
